import React from 'react';

import Loading from '@decisiv/ui-components/lib/components/Loading';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import { PROCESSING_PANEL } from './copy';
import { ProcessingRow } from './styles';

/**
 * Shown while the import runs (Figma 787:76950).
 *
 * The copy is the load-bearing part: it tells the admin outright that closing
 * the window will not interrupt the run. That promise is what the UserEvent
 * feed exists to keep — see useUserEvents.
 */
function ProcessingPanel() {
  return (
    <ProcessingRow>
      <Loading size="small" />
      <div>
        <P weight="semibold" style={{ margin: 0 }}>
          {PROCESSING_PANEL.title}
        </P>
        <P shade={1} size="small" style={{ margin: 0 }}>
          {PROCESSING_PANEL.body}
        </P>
      </div>
    </ProcessingRow>
  );
}

export default ProcessingPanel;
